import request from '@/utils/request'

let Recruitment_infoApi = {

  /*招聘信息列表*/
  list(data) {
    return request._post('/shop/plus.recruitment_info.Index/index', data);
},
/*添加招聘信息*/
add(data) {
    return request._post('/shop/plus.recruitment_info.Index/add', data);
},
auditRecruitment(data){
     return request._post('/shop/plus.recruitment_info.Index/auditRecruitment', data);
},
/*修改招聘信息*/
edit(data) {
    return request._post('/shop/plus.recruitment_info.Index/edit', data);
},
/*删除招聘信息*/
del(data) {
    return request._post('/shop/plus.recruitment_info.Index/del', data);
},
/*招聘信息详情*/
detail(data) {
  return request._post('/shop/plus.recruitment_info.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.recruitment_info.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.recruitment_info.Setting/getSetting', data, errorback);
    },
}
export default Recruitment_infoApi;



// WEBPACK FOOTER //
// ./src/api/recruitment_info.js